"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._AssetFolder = exports._LocalCloudFunctions = exports._DEVCloudFunctions = exports._CloudFunctions = exports._CloudFunctionTypes = exports._CloudRunFunctionEndpoint = exports._CloudFunctionEndpoint = void 0;
exports._GetCloudFunctionUrl = _GetCloudFunctionUrl;
var object_service_1 = require("@src/services/object-service");
var settings_service_1 = require("@src/services/settings.service");
exports._CloudFunctionEndpoint = 'https://europe-west3-named-catcher-373207.cloudfunctions.net';
var _CloudRunFunctionEndpoint = function (endpoint) { return "https://".concat(endpoint, "-729907915433.europe-west3.run.app"); };
exports._CloudRunFunctionEndpoint = _CloudRunFunctionEndpoint;
exports._CloudFunctionTypes = {
    fms: 'fms',
    sendcloud: 'sendcloud',
    fitpay: 'fitpay',
    utilities: 'utilities',
    referral: 'referral',
};
exports._CloudFunctions = {
    fms: (0, exports._CloudRunFunctionEndpoint)('fms-public-endpoint'),
    sendcloud: exports._CloudFunctionEndpoint + '/sendcloud',
    fitpay: (0, exports._CloudRunFunctionEndpoint)('stripe-private-endpoint'),
    utilities: (0, exports._CloudRunFunctionEndpoint)('utilities'),
    referral: (0, exports._CloudRunFunctionEndpoint)('referral-games'),
};
exports._DEVCloudFunctions = {
    fms: (0, exports._CloudRunFunctionEndpoint)('dev-fms-public-endpoint'),
    sendcloud: exports._CloudFunctionEndpoint + '/sendcloud',
    fitpay: (0, exports._CloudRunFunctionEndpoint)('dev-stripe-private-endpoint'),
    utilities: (0, exports._CloudRunFunctionEndpoint)('dev-utilities'),
    referral: (0, exports._CloudRunFunctionEndpoint)('dev-referral-games'),
};
exports._LocalCloudFunctions = {
    fms: 'http://localhost:8085',
    sendcloud: exports._CloudFunctionEndpoint + '/sendcloud',
    fitpay: 'http://localhost:8084',
    utilities: 'http://localhost:8086',
    referral: 'http://localhost:8081',
};
// TODO: Rework once every function uses cloud-run
function _GetCloudFunctionUrl(cloudFunction, env) {
    var config = object_service_1.ObjectService.getInstance(settings_service_1.SettingsService);
    if (!env) {
        env = config.get.environment;
    }
    var value = exports._CloudFunctions[cloudFunction];
    if (env === 'dev') {
        value = exports._DEVCloudFunctions[cloudFunction];
    }
    if (env === 'local') {
        value = exports._LocalCloudFunctions[cloudFunction];
    }
    return value;
}
exports._AssetFolder = 'https://files.fittec.io/files/webflow/new-magicline/assets';
